import { render, staticRenderFns } from "./company-set.vue?vue&type=template&id=417e064a"
import script from "./company-set.vue?vue&type=script&lang=js"
export * from "./company-set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports